(function (Drupal, once) {
  document.addEventListener("DOMContentLoaded", () => {
    const dropdowns = document.querySelectorAll(".press-year-dropdown");

    dropdowns.forEach((dropdown) => {
      const button = dropdown.querySelector("button");
      const menu = dropdown.querySelector(".press-year-menu");
      const icon = dropdown.querySelector("svg");

      if (!button || !menu) return;

      // Toggle dropdown
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = !menu.classList.contains("hidden");

        closeAllDropdowns();

        if (!isOpen) {
          menu.classList.remove("hidden");
          button.setAttribute("aria-expanded", "true");
          icon?.classList.add("rotate-180");
        }
      });
    });

    // Close on click outside
    document.addEventListener("click", () => {
      closeAllDropdowns();
    });

    function closeAllDropdowns() {
      document.querySelectorAll(".press-year-menu").forEach((menu) => {
        menu.classList.add("hidden");
      });

      document
        .querySelectorAll(".press-year-dropdown button")
        .forEach((btn) => {
          btn.setAttribute("aria-expanded", "false");
        });

      document.querySelectorAll(".press-year-dropdown svg").forEach((icon) => {
        icon.classList.remove("rotate-180");
      });
    }
  });
  Drupal.behaviors.pressTabs = {
    attach(context) {
      once("press-tabs", "[data-press-tabs]", context).forEach((nav) => {
        const tabs = nav.querySelectorAll(".tab-link");
        const contents = document.querySelectorAll("[data-tab-content]");
        const isListing = contents.length > 0;

        // Breadcrumb element (last item)
        const breadcrumbCurrent = document.querySelector(".change-name-press");

        // Detect initial tab (default)
        let activeTab = "press";
        const hash = window.location.hash.replace("#", "");

        if (hash === "boletins-medicos") activeTab = "medical";
        if (hash === "notas-de-falecimento") activeTab = "death";

        // -----------------------------------
        // NEW: Detect press node by article class
        // -----------------------------------
        const article = document.querySelector("article.node--type-press");

        if (article) {
          if (article.classList.contains("press-releases")) {
            activeTab = "press";
          } else if (article.classList.contains("medical-bulletins")) {
            activeTab = "medical";
          } else if (article.classList.contains("death-notes")) {
            activeTab = "death";
          }
        }

        // Activate tab and sync breadcrumb
        function activate(tabName) {
          let activeTabLabel = "";

          tabs.forEach((tab) => {
            const isActive = tab.dataset.tab === tabName;
            tab.classList.toggle("active", isActive);

            if (isActive) {
              activeTabLabel = tab.textContent.trim();
            }
          });

          if (isListing) {
            contents.forEach((content) => {
              content.classList.toggle(
                "hidden",
                content.dataset.tabContent !== tabName,
              );
            });
          }

          // Update breadcrumb text (unchanged)
          if (breadcrumbCurrent && activeTabLabel) {
            breadcrumbCurrent.textContent = activeTabLabel;
          }
        }

        // Initial activation
        activate(activeTab);

        // Click handler
        tabs.forEach((tab) => {
          tab.addEventListener("click", (e) => {
            if (!isListing) return; // internal page = normal link

            e.preventDefault();
            const tabName = tab.dataset.tab;

            history.replaceState(null, "", tab.getAttribute("href"));
            activate(tabName);
          });
        });
      });
    },
  };
})(Drupal, once);
